<template>
  <v-select
    @input="loadEvent"
    mandatory
    dense
    class="mt-5 ml-5"
    :value="$store.state.events.selected"
    :items="events"
    placeholder="Select an event"
    item-text="name"
    item-value="_id"
    item-color="green"
  >
    <template slot="selection" slot-scope="data">
      {{ data.item.name }} (Id:{{ data.item._id }})
    </template>
    <template slot="item" slot-scope="data">
      {{ data.item.name }} (Id:{{ data.item._id }})
      <span
        class="pl-3"
        v-if="$store.state.activePollIds.includes(data.item._id)"
      >
        <v-chip x-small dark color="red"><strong>LIVE</strong></v-chip>
      </span>
    </template>
  </v-select>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      events: (state) => state.events.events,
      event: (state) => state.events.event
    })
  },
  async created() {},
  methods: {
    async loadEvent(val) {
      this.$store.commit('SET_NAMESPACE', val);
      location.href = '/admin';
    }
  }
};
</script>
